module.exports = __webpack_public_path__ + "static/media/MB_findDentists@2x.fdc3f965.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/medibank/MB_findDentists@2x.png
// module id = 214
// module chunks = 0